import React, {StrictMode} from 'react';

import {Lang} from '@gravity-ui/uikit';
import getFallbackLanguage from 'common/utils/getFallbackLanguage';
import {createRoot} from 'react-dom/client';
import App from 'ui/components/App';
import WithRenderCallback from 'ui/components/WithRenderCallback';
import {withAppProviders} from 'ui/hocs/withAppProviders';
import configureLang from 'ui/utils/configureLang';
import {initMetrika} from 'ui/utils/initMetrika';
import {rumSendBeforeFrameworkInit, rumSendFrameworkInited} from 'ui/utils/rum';

import 'ui/styles/index.scss';

const lang = window.YC.lang as Lang;

configureLang([Lang.Ru, Lang.En].includes(lang) ? lang : getFallbackLanguage(lang));

initMetrika();

rumSendBeforeFrameworkInit();

const container = document.getElementById('root') as HTMLElement;

const root = createRoot(container);

const AppWithProviders = withAppProviders(App);

root.render(
    <WithRenderCallback callback={rumSendFrameworkInited}>
        <StrictMode>
            <AppWithProviders />
        </StrictMode>
    </WithRenderCallback>,
);
